import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconCodeBlock = ({ color = 'currentColor', size = 'micro', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round">
            <StyledPath
                d="M1.5 14.5C1.23478 14.5 0.98043 14.3946 0.792893 14.2071C0.605357 14.0196 0.5 13.7652 0.5 13.5V2.57667C0.500879 2.29139 0.614596 2.01804 0.81632 1.81632C1.01804 1.6146 1.29139 1.50088 1.57667 1.5H14.4287C14.7125 1.50088 14.9845 1.61403 15.1852 1.81476C15.386 2.01548 15.4991 2.28747 15.5 2.57133V13.4233C15.4991 13.7086 15.3854 13.982 15.1837 14.1837C14.982 14.3854 14.7086 14.4991 14.4233 14.5H1.5Z"
                color="none"
            />
            <StyledPath d="M15.5 4.5H0.5" color="none" />
            <StyledPath d="M11 7.5L13 9.5L11 11.5" color="none" />
            <StyledPath d="M5 7.5L3 9.5L5 11.5" color="none" />
            <StyledPath d="M9 7.5L7 11.5" color="none" />
        </StyledStrokedGroup>
    </StyledSvg>
);
